export const rules = {
	name: {
		required: {
			value: true,
			message:
				'This field cannot be left blank. Please provide a name to save your changes.',
		},
		pattern: {
			value: /^\s*\S+(\s+\S+){0,3}\s*$/,
			message: 'Maximum of 4 words allowed',
		},
	},
	category: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	caseType: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	status: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	company: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	entity: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	defendant: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	place: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	lawyerIds: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
	elegibleStateIds: {
		required: { value: true, message: 'Please fill out the required field.' },
	},
};
